import { EViewMode } from '@enums/ganttTasks';
import { EAddTypeId } from './enums';

export const addActions = [
	{
		text: 'Task',
		id: EAddTypeId.task,
		disabled: false,
	},
	{
		text: 'Milestone',
		id: EAddTypeId.milestone,
		disabled: false,
	},
];

export const timelineViewModeOptions = [
	{
		id: EViewMode.Week,
		label: EViewMode.Week,
		value: EViewMode.Week,
	},
	{
		id: EViewMode.Month,
		label: EViewMode.Month,
		value: EViewMode.Month,
	},
	{
		id: EViewMode.QuarterYear,
		label: 'Quarters',
		value: EViewMode.QuarterYear,
	},
];

export const VIEW_SWITCHER_BREAKPOINT = 1440;
